import React from 'react'

interface EyeProps {
  className?: string
}

const Eye: React.FC<EyeProps> = ({ className }: EyeProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="eye-on">
      <path
        id="Ellipse 167"
        d="M17.5 10C17.5 12.5589 14.1421 16.25 10 16.25C5.85786 16.25 2.5 12.5589 2.5 10C2.5 7.44108 5.85786 3.75 10 3.75C14.1421 3.75 17.5 7.44108 17.5 10Z"
        stroke="#6B6669"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        id="Ellipse 166"
        cx="10"
        cy="10"
        r="2.5"
        stroke="#6B6669"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export default Eye
